export * from './zeit-gespeichert.interface';
